import { Nullable } from "@/general/custom-types/CustomTypes";

export class AnomalyRemovalResponse {
  anomaliesRemovedCount?: Nullable<number>;

  constructor(anomaliesRemovedCount: Nullable<number>) {
    this.anomaliesRemovedCount = anomaliesRemovedCount;
  }
}
